import { useEffect, useMemo, useState } from "react";

const UNITS = [
  ["days", 86400],
  ["hours", 3600],
  ["minutes", 60],
  ["seconds", 1],
];

const split = (secondsLeft) => {
  let rest = Math.max(secondsLeft, 0);
  return UNITS.map(([label, size]) => {
    const value = Math.floor(rest / size);
    rest -= value * size;
    return [label, value];
  });
};

/** Live countdown to the AFCON PAMOJA 2027 kick-off. */
export const Countdown = ({ target, label = "Until kick-off", testId = "afcon-countdown" }) => {
  const targetMs = useMemo(() => new Date(target).getTime(), [target]);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!targetMs || Number.isNaN(targetMs)) return null;
  const secondsLeft = Math.floor((targetMs - now) / 1000);
  const parts = split(secondsLeft);

  return (
    <div data-testid={testId}>
      <p className="overline !text-zinc-500">{secondsLeft > 0 ? label : "Kick-off has arrived"}</p>
      <div className="mt-3 flex flex-wrap gap-px bg-zinc-800">
        {parts.map(([unit, value]) => (
          <div key={unit} className="min-w-[74px] flex-1 bg-[#0b0b0b] px-3 py-3 text-center" data-testid={`countdown-${unit}`}>
            <p className="mono text-2xl font-bold leading-none text-maasai md:text-3xl">
              {String(value).padStart(2, "0")}
            </p>
            <p className="mono mt-1.5 text-[0.5rem] uppercase tracking-[0.2em] text-zinc-500">{unit}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
